import { Mutex } from "@lifeat/shared/util/AsyncUtil";
import { signal } from "@preact/signals-react";

export const isTodoListDataMigrationProcessing$ = signal(false);
export const selectedDetail$ = signal<
    { type: "singular"; taskId: string } | { type: "recurring"; masterId: string; index: number } | null
>(null);
export const draggedTaskEvent$ = signal<
    { type: "singular"; taskId: string } | { type: "recurring"; masterId: string; index: number } | null
>(null);
export const taskManagementOperationMutex = new Mutex();
